/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TaxRateV2Dto as DigiworkMaitreDPosDtoTaxRatesV2TaxRateV2Dto } from '../../models/Digiwork/MaitreD/Pos/DTO/TaxRatesV2/tax-rate-v-2-dto';

export interface GetTaxRate$Params {
  taxRateId: string;
}

export function getTaxRate(http: HttpClient, rootUrl: string, params: GetTaxRate$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoTaxRatesV2TaxRateV2Dto>> {
  const rb = new RequestBuilder(rootUrl, getTaxRate.PATH, 'get');
  if (params) {
    rb.path('taxRateId', params.taxRateId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoTaxRatesV2TaxRateV2Dto>;
    })
  );
}

getTaxRate.PATH = '/api/tax-rates/{taxRateId}';
